export const menuItems = [
  {
    title: "Dashboard",
    root: true,
    icon: "Dashboard-icon.svg",
    page: "/dashboard",
    translate: "MENU.Dashboard",
    isubmenu: "0",
    iscountrequired: "0",
    type: [
      "Requester",
      "Security",
      "Approver",
      "SecurityAdmin",
      "SecurityOfficer",
      "FocalAdmin",
      "ICTAdmin",
    ],
    subpage: [""],
  },
  {
    title: "My Application",
    root: true,
    icon: "My-appliction-icon.svg",
    page: "/",
    translate: "MENU.Myapplication",
    isubmenu: "1",
    iscountrequired: "1",
    type: [
      "Requester",
      "Security",
      "Approver",
      "SecurityAdmin",
      "SecurityOfficer",
      "FocalAdmin",
      "ICTAdmin",
    ],
    subpage: [
      "/draft/list",
      "/revision/list",
      "/pending/list",
      "/approved/list",
      "/rejected/list",
      "/cancelled/list",
      "/pendinggoodsreturn/list",
      "/Pendingconfirmgoodsreturn/list",
      "/securitycancelled/list",
    ],
    submenu: [
      {
        title: "Draft",
        icon: "draft.svg",
        translate: "MENU.draft",
        page: "/draft/list",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "Revision",
        icon: "revision.svg",
        translate: "MENU.revision",
        page: "/revision/list",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "Pending",
        icon: "pendig-icon.svg",
        translate: "MENU.pending",
        page: "/pending/list",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "Approved",
        icon: "approvrd.svg",
        translate: "MENU.approved",
        page: "/approved/list",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "Rejected",
        icon: "rejected.svg",
        translate: "MENU.rejected",
        page: "/rejected/list",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "Cancelled",
        icon: "cancelled.svg",
        translate: "MENU.cancelled",
        page: "/cancelled/list",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "Pending Goods Return",
        icon: "pending-goods-return.svg",
        translate: "MENU.pending_goods_return",
        page: "/pendinggoodsreturn/list",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "Pending Confirm Goods return",
        icon: "pending-goods-confirm-return.svg",
        translate: "MENU.Pending_confirm_goods_return",
        page: "/Pendingconfirmgoodsreturn/list",
        type: ["Requester", "ICTAdmin"],
      },
    ],
  },
  {
    title: "Security Corner",
    root: true,
    icon: "security-corner-20.svg",
    page: "/",
    translate: "MENU.Security.Corner",
    isubmenu: "1",
    iscountrequired: "0",
    type: ["Security", "SecurityAdmin", "ICTAdmin"],
    subpage: [
      "/typeofgoods/typeofgoodsList",
      "/exitentry/update",
      "/Access/AccessList",
    ],
    submenu: [
      {
        title: "Type of Goods",
        icon: "draft.svg",
        translate: "MENU.Type.of.Goods",
        page: "/typeofgoods/typeofgoodsList",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "GGP Exit & Entry update",
        icon: "draft.svg",
        translate: "MENU.GGP.Exit.Entry.update",
        page: "/exitentry/update",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "Access Privilege",
        icon: "draft.svg",
        translate: "MENU.Access.Privilege",
        page: "/Access/AccessList",
        type: ["SecurityAdmin"],
      },
    ],
  },
  {
    title: "Security Corner",
    root: true,
    icon: "approvrd.svg",
    page: "/",
    translate: "MENU.Security.Corner",
    isubmenu: "1",
    iscountrequired: "0",
    type: ["Security", "SecurityOfficer"],
    subpage: ["/exitentry/update"],
    submenu: [
      {
        title: "GGP Exit & Entry update",
        icon: "draft.svg",
        translate: "MENU.GGP.Exit.Entry.update",
        page: "/exitentry/update",
        type: ["Requester"],
      },
    ],
  },
  {
    title: "My Task",
    root: true,
    icon: "approvrd.svg",
    page: "/",
    translate: "MENU.MyTask",
    isubmenu: "1",
    iscountrequired: "1",
    type: ["Approver", "FocalAdmin", "ICTAdmin"],
    subpage: [
      "/mytask/approved/list",
      "/mytask/approved/view",
      "/mytask/approved/workflow",
      "/mytask/pending/list",
      "/mytask/pending/view",
      "/mytask/pending/workflow",
      "/mytask/rejected/list",
      "/mytask/rejected/view",
      "/mytask/rejected/workflow",
    ],
    submenu: [
      {
        title: "Pending",
        icon: "draft.svg",
        translate: "MENU.MyTask_Pending",
        page: "/mytask/pending/list",
        type: ["Approver", "ICTAdmin"],
      },
      {
        title: "Approved",
        icon: "draft.svg",
        translate: "MENU.MyTask_Approved",
        page: "/mytask/approved/list",
        type: ["Approver", "ICTAdmin"],
      },
      {
        title: "Rejected",
        icon: "draft.svg",
        translate: "MENU.MyTask_Rejected",
        page: "/mytask/rejected/list",
        type: ["Approver", "ICTAdmin"],
      },
    ],
  },
  {
    title: "Reports",
    root: true,
    icon: "Reports.svg",
    page: "/",
    translate: "MENU.Reports",
    isubmenu: "1",
    iscountrequired: "0",
    type: [
      "Requester",
      "Security",
      "Approver",
      "SecurityAdmin",
      "SecurityOfficer",
      "FocalAdmin",
      "ICTAdmin",
    ],
    subpage: ["/exitentry/list", "/report/list"],
    submenu: [
      {
        title: "GGP Report",
        icon: "draft.svg",
        translate: "MENU.GGPReport",
        page: "/report/list",
        type: ["Requester", "ICTAdmin"],
      },
      {
        title: "GGP History",
        icon: "draft.svg",
        translate: "MENU.GGPHistory",
        page: "/exitentry/list",
        type: ["Requester", "ICTAdmin"],
      },
    ],
  },
  {
    title: "Delegation",
    root: true,
    icon: "people_alt_white_24dp.svg",
    translate: "MENU.Delagation",
    page: "/Delegation/list",
    type: ["SecurityAdmin", "FocalAdmin", "ICTAdmin"],
    isubmenu: "0",
    iscountrequired: "0",
    subpage: [""],
  },
  // {
  //   title: "Old GGP Link",
  //   root: true,
  //   icon: "old-website.svg",
  //   page: "http://webapps.mmhe.com.my/eggp/_layouts/15/eGGP/Dashboard.aspx",
  //   translate: "MENU.OldDashboard",
  //   isubmenu: "0",
  //   iscountrequired: "0",
  //   type: [
  //     "Requester",
  //     "Security",
  //     "Approver",
  //     "SecurityAdmin",
  //     "SecurityOfficer",
  //     "FocalAdmin",
  //     "ICTAdmin",
  //   ],
  //   subpage: [""],
  // },
];
